import { onScopeDispose, toValue, watch } from "vue";

/** Owns micro-pin GeoJSON features and one clicked-pin anchor on an injected map. */
export function useFinderMapData({ map, maps, scene, feed, icon, selectPin }) {
  let features = [];
  let click;
  let anchor;
  let owner;
  let revision = 0;
  function clear() {
    revision += 1;
    click?.remove();
    click = undefined;
    features.forEach((feature) => owner?.data.remove(feature));
    features = [];
    anchor?.unbindAll?.();
    anchor = undefined;
    owner = undefined;
  }
  async function clicked(event) {
    const current = revision;
    const result = await selectPin(event.feature.getProperty("address_id"));
    if (current !== revision || !result) {
      return;
    }
    anchor.set("position", event.latLng);
    toValue(scene)?.open(result, anchor);
  }
  function render() {
    clear();
    owner = toValue(map);
    const api = toValue(maps);
    const data = toValue(feed);
    if (!owner?.data || !api || !data) {
      return;
    }
    // Returns undefined once Google Maps rejects the key.
    features = owner.data.addGeoJson(data) ?? [];
    owner.data.setStyle({ zIndex: -9, icon: { url: toValue(icon), scaledSize: new api.Size(6, 6) } });
    anchor = new api.MVCObject();
    anchor.set("anchorPoint", new api.Point(0, -10));
    click = owner.data.addListener("click", clicked);
  }
  watch([() => toValue(map), () => toValue(maps), () => toValue(feed), () => toValue(icon)], render, {
    immediate: true,
  });
  onScopeDispose(clear);
}
